import { useState, useEffect } from 'react';
import './ContactForm.css';
import './FeedbackForm.css';

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: 'General Feedback',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const modalElement = document.getElementById('feedbackModal');
    if (modalElement) {
      modalElement.addEventListener('hidden.bs.modal', () => {
        setIsSubmitted(false);
        setFormData({ name: '', email: '', category: 'General Feedback', message: '' });
        setError('');
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.message.trim().length < 10) {
      setError('Message must be at least 10 characters.');
      return;
    }
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        setIsSubmitted(true);
        setTimeout(() => {
          const modalElement = document.getElementById('feedbackModal');
          const modalInstance = window.bootstrap?.Modal.getInstance(modalElement);
          if (modalInstance) modalInstance.hide();
        }, 5000);
      } else {
        setError(data.error || 'Failed to send feedback. Please try again.');
      }
    } catch {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="feedbackModal"
      tabIndex="-1"
      aria-labelledby="feedbackModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content fbk-modal-content">
          <div className="fbk-modal-inner">
            <div className="modal-header border-0 fbk-modal-header">
              <h3 className="modal-title fbk-modal-title" id="feedbackModalLabel">
                Give Feedback
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body fbk-modal-body">
              {!isSubmitted ? (
                <>
                  <p className="fbk-intro">
                    Your feedback helps us build Rusiv around real people. Share what's on your mind, every message is read by the team.
                  </p>

                  {error && <div className="ctp-form-error">{error}</div>}

                  <form onSubmit={handleSubmit} className="ctp-form">
                    <div className="ctp-form-row">
                      <div className="ctp-field">
                        <label htmlFor="fbk-name">Name</label>
                        <input
                          type="text"
                          id="fbk-name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Your name"
                        />
                      </div>
                      <div className="ctp-field">
                        <label htmlFor="fbk-email">Email</label>
                        <input
                          type="email"
                          id="fbk-email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="your@email.com"
                        />
                      </div>
                    </div>

                    <div className="ctp-field">
                      <label htmlFor="fbk-category">Category</label>
                      <select
                        id="fbk-category"
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                      >
                        <option value="General Feedback">General Feedback</option>
                        <option value="Bug Report">Bug Report</option>
                        <option value="Feature Request">Feature Request</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="ctp-field">
                      <label htmlFor="fbk-message">
                        Message <span>*</span>
                      </label>
                      <textarea
                        id="fbk-message"
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        placeholder="Tell us what you think…"
                      />
                    </div>

                    <button type="submit" className="ctp-submit" disabled={isSubmitting}>
                      {isSubmitting ? (
                        <>
                          <span className="ctp-spinner" />
                          Sending…
                        </>
                      ) : (
                        'Send feedback'
                      )}
                    </button>

                    <p className="ctp-privacy">
                      We read every message. Your feedback shapes what we build next.
                    </p>
                  </form>
                </>
              ) : (
                <div className="ctp-success">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <circle cx="24" cy="24" r="23" stroke="var(--accent)" strokeWidth="2" />
                    <path
                      d="M14 24l7 7 13-14"
                      stroke="var(--accent)"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <h3>Feedback received.</h3>
                  <p>Thank you. Your message has been sent to the team, and we appreciate you taking the time.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackForm;
